import { Box, Button, Grid2 } from "@mui/material";
import React, { useState, useEffect } from "react";
import SideBar from "../SideBar/SideBar";
import { useTheme, useMediaQuery } from "@mui/material";
import '../Assistant/Assistant.css';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import Modal from '@mui/material/Modal';
import Stack from "@mui/material/Stack";
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import DeleteIcon from '@mui/icons-material/Delete';
import { ToastContainer, toast } from 'react-toastify';
import { Link, useNavigate } from "react-router-dom";
import './ContactList.css'
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import CreateOutlinedIcon from '@mui/icons-material/CreateOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';


const rows = [
    createData('Frozen yoghurt', 159, 6.0, 24, 4.0),
    createData('Ice cream sandwich', 237, 9.0, 37, 4.3),
    createData('Eclair', 262, 16.0, 24, 6.0),
    createData('Cupcake', 305, 3.7, 67, 4.3),
    createData('Gingerbread', 356, 16.0, 49, 3.9),
  ];
  function createData(name, calories, fat, carbs, protein) {
    return { name, calories, fat, carbs, protein };
  }

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: '#2F024E',
        color: '#fff',
        
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 10,
        border: 'none',
    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(even)': {
        backgroundColor: 'rgba(226, 186, 253, 0.30)',
        border: 'none',
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 'none',
    },
}));


const drawerWidth = 300;
const ContactListTable = () => {
          const notify = () => toast.success('Setup Completed');
          const remove = () => toast.success('Deleted successfully');
        
          const theme = useTheme();
          const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
        
          const [pop, setPop] = useState(false);
          const handlePopOpen = () => setPop(true);
          const handlePopClose = () => setPop(false);
        
          const navigate = useNavigate();
  return (
    <div className="ContactListTable">
    <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
      <SideBar />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: isLgUp ? 5 : 1,
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          marginTop: isLgUp ? "0px" : "80px",
        }}
      >
        <Grid2 container spacing={2}>
          <Grid2
            item
            size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}
            className="mb-20"
          >
            <div className="ContactListTable-main">
            <TableContainer component={Paper} sx={{ maxHeight: 440,  borderRadius:'20px 20px 0px 0px'}}>
                                        <Table sx={{ minWidth: 700 }} stickyHeader aria-label="sticky table">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell align="center">Name</StyledTableCell>
                                                    <StyledTableCell align="center">Created At</StyledTableCell>
                                                    <StyledTableCell align="center">Description</StyledTableCell>
                                                    <StyledTableCell align="center">Total Contacts</StyledTableCell>
                                                    <StyledTableCell align="center">Action</StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row) => (
                                                    <StyledTableRow key={row.name}>
                                                        <StyledTableCell component="th" scope="row"><Link to='/contact-list-view'><h4> Contact_1</h4> </Link></StyledTableCell>
                                                        <StyledTableCell align="center"><h4>Dec 10, 01:54 pm</h4></StyledTableCell>
                                                        <StyledTableCell align="center" sx={{maxWidth:'300px'}}><p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type </p>   </StyledTableCell>
                                                        <StyledTableCell align="center"><h4>0</h4></StyledTableCell>
                                                        <StyledTableCell align="center">  <Stack direction="row" spacing={2} sx={{justifyContent:'center'}}>  <CreateOutlinedIcon onClick={handlePopOpen} sx={{cursor:'pointer'}}/>
                                                            <DeleteOutlineOutlinedIcon/>
                                                            </Stack></StyledTableCell>
                                                    </StyledTableRow>
                                                    
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                    <div className="modal-popup">
                <Modal
                  open={pop}
                  onClose={handlePopClose}
                  aria-labelledby="modal-modal-title"
                  aria-describedby="modal-modal-description"
                >
                  <Box className="common-modal-box">
                    <Typography id="modal-modal-title" variant="h6" component="h2">
                    Create Contact List 
                    </Typography>
                    <div className="assistant-cnt">
                      <div className="input-common mt-20">
                        <label> Name *</label>
                        <TextField fullWidth id="fullWidth" />
                      </div>
                      <div className="input-common mt-20">
                        <label>Description (optional) *</label>
                        <TextField multiline rows={5} fullWidth id="fullWidth" />
                      </div>
                    </div>
                    <Stack direction="row" spacing={2} sx={{ justifyContent: "center" }} className="mt-20">
                      <div className="border-graient mt-10">
                        <Button>Cancel</Button>
                      </div>
                      <div className="border-graient gradient-bg mt-10">
                        <Button
                          onClick={() => {
                            navigate("/contact-list-table");
                          }}
                        >Save</Button>
                      </div>
                    </Stack>
                  </Box>
                </Modal>
              </div>

            </div>
          </Grid2>
        </Grid2>
      </Box>
    </Box>
  </div>
  )
}

export default ContactListTable